<template>
    <v-container fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" align="center">
                <v-card width="400" class="pa-1">
                    <Title
                        title="圃場管理システムログイン" dense>
                        <v-spacer />
                        <template v-if="users != null && users.length > 1" >
                            <v-menu offset-y absolute close-on-content-click>
                                <template v-slot:activator="{ on }">
                                    <v-btn small icon v-on="on">
                                        <v-icon>mdi-account</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item v-for="user in users" :key="user.id" @click="onClickUser(user)">
                                        <v-list-item-content>
                                            <!-- {{user.email}} -->
                                            <v-card outlined>
                                                <v-card-text>
                                                    {{user.email}}<br/>
                                                    <span style="font-size:xx-small; white-space:nowrap">最終ログイン:{{(new Date(user.lastLoggedInDate)).toFormatString("yyyy-MM-dd HH:mm:ss")}}</span>
                                                </v-card-text>
                                            </v-card>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                    </Title>
                    <v-form ref="form">
                        <v-card-text class="pa-3">
                            <v-text-field 
                                v-model="email" 
                                label="メールアドレス"
                                clearable
                                :rules="[validatorRequire]" />
                            <v-text-field 
                                v-model="password" 
                                label="パスワード" 
                                type="password"
                                clearable
                                :rules="[validatorRequire]"
                                ref="password" />
                            <v-checkbox v-model="isRegistUser" label="ユーザーを保存する" />
                        </v-card-text>
                    </v-form>
                    <v-card-actions class="pa-1">
                        <v-btn text color="red" small @click="onClickForgetPassword">パスワードを忘れた時</v-btn>
                        <v-spacer />
                        <v-btn color="primary" @click="onClickLogin">ログイン</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Confirm ref="confirm" />
    </v-container>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import db from '@/firebase/firestore.js'
    import fb from '@/firebase/firebase.js'
    import Title from '@/components/seedling/items/TitleBar'
    import Confirm from '@/components/tools/ConfirmDialog';
    import crypto from "crypto-js"

    export default {
        components: {
            Title,
            Confirm
        },
        props: {
            loggedInListener: null
        },
        data: function () {
            return {
                email: "",
                password: "",
                isRegistUser: true,
                users: [],
                validatorRequire: value => !!value || '必須入力です。',
            }
        },
        computed: {
            localDB: function () {
                return this.$store.getters["localDB"]
            }
        },
        created: function () {

            // スクロールを先頭に戻す
            window.scrollTo(0, 0)

            const self = this
            // this.localDB.users.delete()
            this.users = []
            this.localDB.users.orderBy("lastLoggedInDate").desc().toArray((users)=>{
                users.forEach(function(user){
                    self.users.push(user)
                })
                if (users.length > 0) {
                    self.email = users[0].email
                    self.password = crypto.AES.decrypt(users[0].password, users[0].email).toString(crypto.enc.Utf8)
                }
            }).catch(function(error){
                console.log(error)
            })
        },
        methods: {
            /**
             * ユーザー選択時
             */
            onClickUser: function (user) {
                this.$refs.password.focus()
                this.email = user.email
                this.password = ""
            },
            /**
             * "パスワードを忘れた時は" を押下時
             */
            onClickForgetPassword: function () {
                this.$refs.confirm.show({
                    title: "パスワードを忘れた時は",
                    message: "パスワードを忘れた時は、下記へご連絡下さい。<br/>有限会社トムソン System Lab<br/><strong>TEL:0942-27-6104/090-1513-5218</strong>",
                    width: 500,
                    buttonYes: "閉じる",
                    buttonNo: "",
                })
            },
            /**
             * ログインボタン押下時
             */
            onClickLogin: function () {

                if (!this.$refs.form.validate()) {
                    return
                }

                const self = this

                const loggedIn = function () {

                    self.localDB.users.where("email").equals(self.email).first().then(function(record){
                        if (self.isRegistUser) {
                            if (record == null) {
                                self.localDB.users.add(
                                    {
                                        email: self.email,
                                        password: crypto.AES.encrypt(self.password, self.email).toString(),
                                        lastLoggedInDate: (new Date()).getTime()
                                    }
                                )
                            } else {
                                self.localDB.users.update(record.id, {lastLoggedInDate: (new Date()).getTime()})
                            }
                        } else {
                            if (record != null) {
                                self.localDB.users.delete(record.id)
                            }
                        }
                    }).catch(function(error){
                        console.log(error)
                    })

                    const user = fb.auth().currentUser
                    self.loggedInListener(user)
                }

                this.$store.commit("processing", {start:true, message:"ログイン中です…。"})
                fb.auth().signInWithEmailAndPassword(this.email, this.password).then(function(){
                    console.log("success")
                    self.$store.commit("processing")
                    loggedIn()
                }).catch (function (error) {
                    self.$store.commit("processing")
                    switch (error.code) {
                        case "auth/user-not-found":
                            console.log("user not found!! new user create", error)
                            self.$refs.confirm.show({
                                title: "アカウントの作成",
                                message: "圃場管理システムの新しいアカウントを登録しますか？",
                                width: 500,
                                buttonYes: "登録する",
                                buttonNo: "しない",
                                listenerYes: function () {
                                    fb.auth().createUserWithEmailAndPassword(self.email, self.password).then(function(){
                                        loggedIn()
                                    }).catch (function (error) {
                                        console.log("new user create failed!!!", error)
                                    })
                                    return true
                                },
                            })
                            break;
                        default:
                            self.$refs.confirm.show({
                                title: "ログインエラー",
                                message: "ログイン出来ません。<br/>メールアドレスかパスワードが間違っている、もしくは<br/>他の端末でパスワードが変更された可能性があります。",
                                buttonYes: "戻る",
                                buttonNo: "",
                            })
                            console.log("failed", error, error.code)
                            break;
                    }
                })
            }
        }
    }
</script>

                db.operationLog.put({
                    dateTime: this.df_currentDateTime(),
                    path: path,
                    data: data == undefined || data == null ? "" : JSON.stringify(data)
                })
